import { render, staticRenderFns } from "./too-long-on-status.vue?vue&type=template&id=af77142e"
import script from "./too-long-on-status.vue?vue&type=script&lang=js"
export * from "./too-long-on-status.vue?vue&type=script&lang=js"
import style0 from "./too-long-on-status.vue?vue&type=style&index=0&id=af77142e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports